import React from 'react';
import { classes } from '../CUtil';

const OurLogo = (props) => {
	const is_sponsored_logo = !!props.sponsored;
	const cls = classes("ad_navbar_brand_logo", is_sponsored_logo && "ad_sponsored_brand_logo", props.className);
	let alt, src;
	const dark = !!props.dark;

	if (IS_BT || IS_EUROINVESTOR || IS_BERLINGSKE || IS_TEST) {
		if (is_sponsored_logo) {
			alt = "Millionærklubbens Aktiespil - sponsoreret af Codan og DCC Energi";
			src = "/gfx/euroinvestor-millionaerklubben-sponsored.svg";
		} else {
			alt = "Aktiedysten";;
			src = dark ? "https://aktiedysten-static-v2.s3.eu-north-1.amazonaws.com/gfx/millionaerklubbens-aktiespil-header.svg" : "https://aktiedysten-static-v2.s3.eu-north-1.amazonaws.com/gfx/millionaerklubbens-aktiespil-header.svg";
		}
	}
	return <img alt={alt} className={cls} src={src}/>;
}

export default OurLogo;



// WEBPACK FOOTER //
// ./src/c/OurLogo.js